import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import AICampusFooter from '@/components/probaworkflows_base_components/AICampusFooter/AiFooter.vue';

export default{
    name: 'ViewContracts',

    components: {
        GlobalTable,
        AICampusFooter,
    },

    data: () => ({
        active_tab: 'Invoices',
        tabs: ['Invoices', 'Payment history'],
        contracts: [
        {
          number: '#0001',
          contract_name: 'Maintenance Agreement',
          date_sent: '17/10/2022',
          due_date: '30/12/2020',
          status: 'Signed',
        },
        {
          number: '#0001',
          contract_name: 'Service Agreement Contract',
          date_sent: '12/02/2021',
          due_date: '27/04/2020',
          status: 'Pending signature',
        },
        {
          number: '#0001',
          contract_name: 'Partnership Agreement',
          date_sent: '02/02/2024',
          due_date: '28/04/2020',
          status: 'Overdue',
        }
      ],
    }),
}